import * as am4core from '@amcharts/amcharts4/core'

export default function daqsTheme (target) {
  if (target instanceof am4core.ColorSet) {
    // target.list = [
    //   am4core.color('#078282'),
    //   am4core.color('#dba486'),
    //   am4core.color('#cde0a2')
    // ]
    target.list = [
      am4core.color('#016c59'),
      am4core.color('#66c2a4'),
      am4core.color('#b2e2e2'),
      am4core.color('#edf8fb')
    ]
  }
}
